import React, { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { fetchAuthSession } from "aws-amplify/auth";
import {
  Container,
  Form,
  Button,
  Message,
  Segment,
  Header,
  Checkbox,
} from "semantic-ui-react";

const MileageForm = () => {
  const { fullName } = useOutletContext();

  const [formData, setFormData] = useState({
    date: "",
    fromLocation: "",
    toLocation: "",
    miles: "",
    roundTrip: false,
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const LAMBDA_URL = "https://rtetpzpjnb2em7lyzvjhy7srcm0fjwbj.lambda-url.us-east-2.on.aws/";

  const totalMiles =
    Number(formData.miles || 0) * (formData.roundTrip ? 2 : 1);

  const handleChange = (e, { name, value, checked, type }) => {
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async () => {
    setSuccess("");
    setError("");

    if (
      !formData.date ||
      !formData.fromLocation ||
      !formData.toLocation ||
      !formData.miles
    ) {
      setError("Please fill out all required fields.");
      return;
    }

    if (Number(formData.miles) <= 0) {
      setError("Miles must be greater than 0.");
      return;
    }

    try {
      setLoading(true);

      const session = await fetchAuthSession();
      const idToken = session.tokens?.idToken?.toString();

        const response = await fetch(LAMBDA_URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                employeeName: fullName,
                date: formData.date,
                fromLocation: formData.fromLocation,
                toLocation: formData.toLocation,
                miles: Number(formData.miles),
                roundTrip: formData.roundTrip,
            }),
            });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Mileage submission failed.");
      }

      setSuccess("Mileage submitted successfully.");
      setFormData({
        date: "",
        fromLocation: "",
        toLocation: "",
        miles: "",
        roundTrip: false,
      });
    } catch (err) {
      console.error(err);
      setError(err.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container style={{ maxWidth: "700px", marginTop: "40px" }}>
      <Segment padded>
        <Header as="h2">Mileage Submission</Header>
        <p>
          Submit mileage for company travel.
        </p>

        {success && <Message positive content={success} />}
        {error && <Message negative content={error} />}

        <Form onSubmit={handleSubmit}>
          <Form.Input
            label="Employee"
            value={fullName || "Current User"}
            readOnly
          />

          <Form.Input
            required
            label="Date"
            name="date"
            type="date"
            value={formData.date}
            onChange={handleChange}
          />

          <Form.Input
            required
            label="From"
            name="fromLocation"
            placeholder="Example: Office"
            value={formData.fromLocation}
            onChange={handleChange}
          />

          <Form.Input
            required
            label="To"
            name="toLocation"
            placeholder="Example: 123 Main St, Harrisburg, PA"
            value={formData.toLocation}
            onChange={handleChange}
          />

          <Form.Input
            required
            label="Miles"
            name="miles"
            type="number"
            step="0.1"
            min="0"
            placeholder="Example: 12.5"
            value={formData.miles}
            onChange={handleChange}
          />

          <Form.Field>
            <Checkbox
              label="Round Trip?"
              name="roundTrip"
              checked={formData.roundTrip}
              onChange={handleChange}
            />
          </Form.Field>

          <Message>
            <strong>Total Miles:</strong> {totalMiles.toFixed(1)}
          </Message>

          <Button primary loading={loading} disabled={loading}>
            Submit Mileage
          </Button>
        </Form>
      </Segment>
    </Container>
  );
};

export default MileageForm;